import * as React from 'react';
const SvgErrorDiamondFill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.15 12.953c.23.704.84 1.314 2.061 2.535l3.3 3.3c1.222 1.222 1.832 1.832 2.536 2.061.62.201 1.287.201 1.906 0 .704-.229 1.314-.84 2.535-2.06l3.3-3.3c1.222-1.222 1.832-1.832 2.061-2.536a3.1 3.1 0 0 0 0-1.906c-.229-.704-.84-1.314-2.06-2.535l-3.3-3.3C14.266 3.99 13.656 3.38 12.952 3.15a3.1 3.1 0 0 0-1.906 0c-.704.229-1.314.84-2.535 2.06l-3.3 3.3C3.99 9.734 3.38 10.344 3.15 11.048a3.1 3.1 0 0 0 0 1.906M12 7c-.667 0-1.195.573-1.147 1.247l.353 5.005A.8.8 0 0 0 12 14a.8.8 0 0 0 .794-.748l.353-5.005A1.16 1.16 0 0 0 12 7m0 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgErrorDiamondFill;
